import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'
import { FileManager } from 'components/FileManager'

const useStyles = makeStyles((theme) => ({
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  item: {
    marginTop: theme.spacing(1),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
}))

export const FormFotos = (props) => {
  const { cadaverForm } = props
  const classes = useStyles()
  const [arquivosIniciais, setArquivosIniciais] = useState([])

  // Função de callback estável para notificar e atualizar o estado do formulário emulador
  const setArquivosPai = useCallback((novosIds) => {
    cadaverForm.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        arquivos: novosIds,
      },
    }))
  }, [])

  useEffect(() => {
    setArquivosIniciais(cadaverForm.formState.values.arquivos)
  }, [])

  return (
    <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <FileManager
          rotaUpload="/arquivo/cadaver"
          rotaLoadImagem="/arquivo/cadaver"
          setArquivosPai={setArquivosPai}
          arquivosIniciais={arquivosIniciais}
          tipos={['pdf']}
        />
      </Grid>
    </Grid>
  )
}

FormFotos.propTypes = {
  cadaverForm: PropTypes.object.isRequired,
  processando: PropTypes.bool,
  setProcessando: PropTypes.func,
}

